import { defineStore } from "pinia";
import { useApi } from "@/core/http";

const { get_data } = useApi();

export const useMaintenance = defineStore("maintenance", {
    state: () => ({
        maintenanceStatus: false,
        startTime: "00:00:00",
        endTime: "00:00:00",
        timeLeft: 0,
        message: "",
        timerInterval: null
    }),
    getters: {
        isMaintenance: (state) => state.maintenanceStatus,
        maintenanceMessage: (state) => {
            const formattedTime = formatTimeLeft(state.timeLeft);
            return state.message.replace("{{ timeLeft }}", formattedTime);
        },
    },
    actions: {
        async checkMaintenance() {
            try {
                const response = await get_data('/maintenances');
                if (response?.data?.status !== 'active') {

                    this.message = response?.data?.message;
                    this.startTime = response?.data?.start_time || "00:00:00";
                    this.endTime = response?.data?.end_time || "00:00:00";

                    if (import.meta.env.VITE_APP_ENV === 'production') {
                        this.maintenanceStatus = true;
                        this.startCountdown();
                    } else {
                        this.maintenanceStatus = false;
                    }
                } else {
                    this.maintenanceStatus = false;
                    this.timeLeft = 0;
                }
            } catch (error) {
                this.message = error.message || error;
                this.maintenanceStatus = false;
            }
        },

        // Démarrer le décompte du temps restant
        startCountdown() {
            const endTimeStamp = new Date(this.endTime.replace(" ", "T")).getTime();

            const updateTime = () => {
                const currentTime = new Date().getTime();
                const remainingTime = Math.max(endTimeStamp - currentTime, 0);
                this.timeLeft = Math.floor(remainingTime / 1000);

                if (remainingTime <= 0) {
                    clearInterval(this.timerInterval);
                    this.maintenanceStatus = false;
                }
            };

            this.timerInterval = setInterval(updateTime, 1000);
            updateTime();
        }
    }
});

function formatTimeLeft(timeLeft) {
    if (isNaN(timeLeft) || timeLeft <= 0) {
        return "00:00:00";
    }

    const hours = Math.floor(timeLeft / 3600);
    const minutes = Math.floor((timeLeft % 3600) / 60);
    const seconds = timeLeft % 60;

    return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
}